import { CREATE_PLAYERS_LOADING, CREATE_PLAYERS_SUCCESS, CREATE_PLAYERS_ERROR, GET_A_TOURNAMENT_LIST_ERROR, GET_A_TOURNAMENT_LIST_SUCCESS, GET_A_TOURNAMENT_LIST_LOADING } from "../../../constant/actionTypes";

const getOneTournament = (state = {}, action) => {
    switch (action.type) {
        case GET_A_TOURNAMENT_LIST_LOADING: {
            let obj = {
                loading: true
            };
            return obj;
        }
        case GET_A_TOURNAMENT_LIST_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response,
            };
            return obj;
        }
        case GET_A_TOURNAMENT_LIST_ERROR: {
            let obj = {
                loading: false,
                status: action.response
            };
            return obj;
        }
        default:
            return state;
    }
}

export default getOneTournament;